import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {ImageSeeker, ModalSeeker} from "@ui-seeker/core";
import {Box, Grid} from "@mui/material";

import {HierarchicalTextBlock} from "@components";
import ProductPagesModalSkuBlock from "../SkuBlock";


export default function ProductPagesDetailsImagesModal({ isOpen, controller, data, isRichContent }) {
	const currentPos = useSignal(0)
	const images = !isRichContent ? data.images : data.imagesRichContent
	const imageData = images[currentPos.value]

	return <ModalSeeker
		hideActions
		isOpen={isOpen}
		controller={controller}
		size="md"
		title='Images in gallery'
	>
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<ProductPagesModalSkuBlock
					date={data.date}
					company={data.company}
					category={data.category}
					productID={data.productID}
					siteID={data.siteID}
					sku={data.skuName}
					brand={data.brand}
					country={data.country}
					retailer={data.retailer}
					siteURL={data.siteURL}
					ean={data.ean}
					supertitle={data.supertitle}
					productTitle={data.productTitle}
					subtitle={data.subtitle}
					brandRaw={data.brand}
				/>
			</Grid>
		</Grid>

		<Grid item xs={12}>
			<HierarchicalTextBlock
				supertitle="Position:"
				supertitleValue={`${imageData?.position} of ${images?.length}`}
			/>
		</Grid>
		<Grid item xs={12}>
			<HierarchicalTextBlock
				supertitle="Picture Size:"
				supertitleValue={`${imageData?.width}x${imageData?.height}`}
			/>
		</Grid>
		<Grid item xs={12}>
			<HierarchicalTextBlock
				supertitle="Format:"
				supertitleValue={imageData?.format}
			/>
		</Grid>

		<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
			<ImageSeeker src={imageData?.multimediaURL} sx={{ height: 'auto', width: 1 }} />
		</Grid>

		<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: .5, cursor: 'pointer', flexWrap: 'wrap' }}>
			{ images.map(({ multimediaURL }, idx) => <Box
				key={idx}
				onClick={() => currentPos.value = idx}
				sx={{ ...idx === currentPos.value && {
					border: '3px solid',
					borderColor: 'primary.main'
				}}}
			>
				<ImageSeeker src={multimediaURL} sx={{ height: 50 }} />
			</Box>) }
		</Grid>
	</ModalSeeker>
}